<template>
    <div class="bg-white p-6 rounded-lg border">
        <h3 class="text-lg font-medium text-gray-900 mb-4 text-center">Tareas Finalizadas por Proceso</h3>
        <div class="flex justify-center items-center h-[calc(100%-3rem)]">
            <canvas ref="chartCanvas" id="chartByProcess"></canvas>
        </div>
    </div>
</template>

<script setup lang="ts">
import { watchEffect, defineProps, ref } from 'vue';
import { Chart } from 'chart.js/auto';
import ICountTaskByProcess from '@/interfaces/ICountTaskByProcess';

const props = defineProps({
    items: {
        type: Array as () => Array<ICountTaskByProcess>,
        required: true
    }
});

const chartCanvas = ref<HTMLCanvasElement | null>(null);
let chart: Chart | null = null;

const createChart = () => {
    if (!chartCanvas.value) return;
    
    if (chart) {
        chart.destroy();
    }

    if (props.items.length > 0) {
        chart = new Chart(chartCanvas.value, {
            type: 'bar',
            data: {
                labels: props.items.map(item => item.process),
                datasets: [{
                    label: 'Cantidad de tareas',
                    data: props.items.map(item => item.count),
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.7)',
                        'rgba(54, 162, 235, 0.7)',
                        'rgba(255, 206, 86, 0.7)',
                        'rgba(75, 192, 192, 0.7)',
                        'rgba(153, 102, 255, 0.7)',
                        'rgba(255, 159, 64, 0.7)',
                        'rgba(0, 153, 204, 0.7)',
                        'rgba(255, 99, 255, 0.7)',
                        'rgba(45, 192, 86, 0.7)'
                    ],
                    borderColor: [
                        'rgb(255, 99, 132)',
                        'rgb(54, 162, 235)',
                        'rgb(255, 206, 86)',
                        'rgb(75, 192, 192)',
                        'rgb(153, 102, 255)',
                        'rgb(255, 159, 64)',
                        'rgb(0, 153, 204)',
                        'rgb(255, 99, 255)',
                        'rgb(45, 192, 86)'
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'right',
                        display: false
                    },
                    title: {
                        display: false
                    }
                },
                scales: {
                    x: {
                        display: false
                    },
                    y: {
                        beginAtZero: true
                    }
                },
                animation: {
                    duration: 1500,
                    easing: 'easeOutQuart',
                    delay: (context) => {
                        return context.dataIndex * 100;
                    }
                }
            }
        });
    }
};

watchEffect(() => {
    if (chartCanvas.value) {
        createChart();
    }
});
</script>